import React from 'react';

import Select from 'react-select';

import { inlineStyles, getOptions } from 'helpers/react_select_helpers';
import { getSelectValue, parseSelectValue, propTypes } from './option';
import OptionRow from './option_row';

class Enum extends React.Component {
  static propTypes = propTypes;

  static type = 'enum'

  handleChange = (selectOption) => {
    this.props.onChange({
      [this.props.option.id]: parseSelectValue(this.props.option, selectOption)
    });
  }

  renderInputs = () => {
    return (
      <Select
        isDisabled={this.props.disabled}
        isClearable={false}
        isMulti={this.props.option.multiselect}
        menuPosition="fixed"
        options={getOptions(this.props.option.values)}
        styles={inlineStyles}
        value={getSelectValue(this.props.option, this.props.value)}
        onChange={this.handleChange}
      />
    );
  }

  renderHiddenValue = () => {
    let value = getSelectValue(this.props.option, this.props.value);
    if (this.props.option.multiselect) {
      value = value.length === 0 ? false : value.map(option => option.label).join(', ');
    } else {
      value = value.label;
    }

    return `Hidden (${value || '<Blank>'})`;
  }

  render() {
    return (
      <OptionRow
        {...this.props}
        inputsClassName="enum"
        renderHiddenValue={this.renderHiddenValue}
        renderInputs={this.renderInputs}
      />
    );
  }
}

export default Enum;
